import { connect } from 'react-redux';
import { compose, withHandlers, setDisplayName } from 'recompose';

import { toggleLoader, toggleMiniMode } from './_actions';

const withLoader = compose(
  setDisplayName('Loader'),
  connect(
    null,
    { toggleLoaderAction: toggleLoader, toggleMiniModeAction: toggleMiniMode },
  ),
  withHandlers({
    toggleLoader: ({ toggleLoaderAction }) => (visible = true) => toggleLoaderAction(visible),
    toggleMiniMode: ({ toggleMiniModeAction }) => (miniMode) => toggleMiniModeAction(miniMode)
  }),
);

export default withLoader;



// WEBPACK FOOTER //
// ./src/modules/app/withLoader.js